// import { config } from 'dotenv';

// config();
// const env = "dev";
const APP_ENV = process.env.REACT_APP_ENVIRONMENT;
const APP_URL = process.env.REACT_APP_BASE_URL;
const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
const CURRENCY_URL = process.env.REACT_APP_CURRENCY_URL;

export { APP_URL, APP_ENV, CURRENCY_API_KEY, CURRENCY_URL };
